import { BillingTier } from "../../../__generated__/gql/graphql";
import PurchaseCreditsModal from "../../../pages/Settings/Billing/CreditsCard/PurchaseCreditsModal/PurchaseCreditsModal";
import ChangePlanModal from "../../../pages/Settings/Billing/PlanCard/ChangePlanModal/ChangePlanModal";
import useUser from "../../../providers/UserProvider/useUser";
import Button from "../../../ui/Button/Button";
import { Coins, Flag, Link } from "../../../ui/Icon/Icon";
import Modal from "../../../ui/Modal/Modal";
import TileButton from "../../../ui/TileButton/TileButton";
import { useDisclosure } from "../../../ui/util/useDisclosure";
import styles from "./InsufficientKeywordCreditsModal.module.scss";

function InsufficientKeywordCreditsModal({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  const { billingInfo, userOrganizations } = useUser();
  const [purchaseCreditsModalOpened, purchaseCreditsModal] = useDisclosure();
  const [changePlanModalOpened, changePlanModal] = useDisclosure();

  return (
    <>
      <PurchaseCreditsModal
        defaultValue="keywords"
        isOpen={purchaseCreditsModalOpened}
        onClose={purchaseCreditsModal.close}
      />
      <ChangePlanModal
        isOpen={changePlanModalOpened}
        onClose={changePlanModal.close}
      />
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title="You've run out of keyword credits"
        subtitle={`You do not have enough credits to search for any more keywords. Select an option to continue.`}
      >
        <div className={styles.buttons}>
          {billingInfo.billingTier !== BillingTier.Scale && (
            <TileButton
              IconComponent={Flag}
              onClick={() => {
                changePlanModal.open();
                onClose();
              }}
              title="View plans"
              subtitle={
                billingInfo.billingTier === BillingTier.Free
                  ? "Subscribe to a plan"
                  : "Upgrade your plan"
              }
            />
          )}
          <TileButton
            IconComponent={Coins}
            onClick={() => {
              purchaseCreditsModal.open();
              onClose();
            }}
            title="Purchase extra credits"
            subtitle="Pay as you go"
          />
          {userOrganizations && userOrganizations.length > 1 && (
            <TileButton
              IconComponent={Link}
              onClick={() => {
                window.open(
                  "https://docs.macawhq.com/en/articles/9900973-linked-teams",
                  "_blank",
                );
                onClose();
              }}
              title="Link existing team"
              subtitle="Share credits from another team"
            />
          )}
        </div>
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
          <Button variant="outline" size="small" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </Modal>
    </>
  );
}

export default InsufficientKeywordCreditsModal;
